import React,{useEffect} from 'react';
import PageTitle from '../../components/common/PageTitle';
import Header from '../../components/common/Header';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';
import NotificationList from '../../components/Notification/NotificationList';
import {useNavigate} from 'react-router-dom';

const Notifications = () => {
  const navigate = useNavigate()
  useEffect(() => {
    sessionStorage.getItem('userDetail') ?  navigate('/notifications') : navigate('/login');
},[]);

  return (
    <>
    <Header/>
   <section className="pt-5 pb-5 content-section notification">
      <div className="container">
        <PageBreadcrumbs pagename="Notification"/>
        
        <div className="row justify-content-center mt-4">
            <div className="col-lg-10">
                   <NotificationList 
                   title="ASAT Exam Result" 
                   description="Some quick example text to build on the card title and make up the bulk of the card's content." /> 

                 
            </div>
        </div>

        </div>

    </section>
</>
  )
}

export default Notifications
